/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "2c7458f83ce5dc471947bf1a8877a3f094baf139";
